import React, { useEffect } from "react";
import { Groups, Security, Diversity3, School, ArrowForward } from "@mui/icons-material";
import { Button, Container } from "@mui/material";
import { useNavigate } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";

import ChairmanImg from "../Assets/KPS_Chairman.jpg";
import DirectorImg from "../Assets/KPS_Director.jpg";
import ManagerImg from "../Assets/KPS_Manager.jpeg";

const Feature = () => {
  const navigate = useNavigate();

  useEffect(() => {
    AOS.init({ duration: 900, once: true });
  }, []);

  const whyUs = [
    { icon: <School />, title: "Technology" },
    { icon: <Groups />, title: "Best Tutor" },
    { icon: <Security />, title: "Practical Training" },
    { icon: <Diversity3 />, title: "Support" },
  ];

  return (
    <div className="overflow-hidden">
      <section className="relative py-32 bg-white overflow-hidden">
        <div className="absolute -top-32 -right-32 w-[500px] h-[500px] bg-red-100 rounded-full blur-3xl opacity-60" />
        <div className="absolute bottom-0 left-0 w-[400px] h-[400px] bg-red-50 rounded-full blur-3xl opacity-60" />

        <Container maxWidth="lg" className="relative">
          <div className="grid lg:grid-cols-12 gap-14 items-center">

            <div className="lg:col-span-7" data-aos="fade-right">
              <span className="inline-block mb-4 text-sm font-semibold tracking-widest text-red-600 uppercase">
                About Krishna Public School
              </span>

              <h2 className="text-[42px] md:text-[52px] font-extrabold text-[#0A1F44] leading-tight mb-8">
                Education that Builds<br />
                Character & Confidence
              </h2>

              <div className="space-y-6 text-lg text-gray-700 leading-relaxed max-w-2xl">
                <p>
                  Krishna Public School (KPS) is thoughtfully designed with modern
                  infrastructure and advanced smart learning techniques to create a
                  dynamic and engaging academic environment.
                </p>

                <p>
                  Guided by experienced and motivated educators, we focus on
                  nurturing curiosity, discipline, and values that shape students
                  into confident individuals prepared for life beyond classrooms.
                </p>

                <p className="font-medium text-gray-900">
                  At KPS, education goes beyond curriculum — it empowers children
                  for lifelong success.
                </p>
              </div>
            </div>

            <div className="lg:col-span-5 grid grid-cols-1 sm:grid-cols-2 gap-6" data-aos="fade-left">

              {whyUs.map((item, i) => (
                <div
                  key={i}
                  className={`relative group rounded-2xl p-6 
              bg-gradient-to-br from-white to-red-50 
              border border-red-100 shadow-md
              transition-all duration-300
              hover:-translate-y-1 hover:shadow-xl
              ${i % 2 === 1 ? "sm:translate-y-8" : ""}`}
                >
                  <div className="absolute inset-0 rounded-2xl bg-red-600 opacity-0 group-hover:opacity-[0.03] transition" />

                  <div className="flex items-center gap-4">
                    <div className="bg-red-600 text-white p-3 rounded-xl">
                      {item.icon}
                    </div>
                    <h3 className="font-semibold text-gray-900 text-base">
                      {item.title}
                    </h3>
                  </div>
                </div>
              ))}

            </div>

          </div>
        </Container>
      </section>

      <section className="py-28 bg-white">
        <Container maxWidth="lg">
          <div className="grid md:grid-cols-2 gap-16 items-center">

            <div data-aos="fade-right">
              <img src={ChairmanImg} alt="Chairman" className="rounded-3xl shadow-2xl object-cover object-top w-full max-h-[500px]" />
            </div>

            <div data-aos="fade-left">
              <h2 className="text-4xl font-bold text-[#0A1F44] mb-6">
                From the Chairman’s Desk
              </h2>

              <p className="text-lg text-gray-700 leading-relaxed">
                Encouraged by my parents, Late Shri Ram Prakash Porwal and
                Smt. Vidhyawati Porwal, I overcame the lack of quality education
                in Sikandra and, against all odds, was able to become a doctor.
                This journey shaped my belief that access to quality education
                can transform lives.
                <br /><br />
                With this vision, Krishna Public School was established to bring
                world-class education to rural Sikandra. KPS will play a vital
                role in enabling our children to compete with the best in the
                country and empower them for life.
                <br /><br />
                I congratulate the engineers, construction workers, faculty, and
                staff for creating this remarkable institution and taking the
                first step toward a brighter future for our children.
              </p>

              <div className="mt-6 border-l-4 border-red-600 pl-4">
                <p className="font-bold">Dr. Anil Kr. Porwal</p>
                <p className="text-red-600 font-semibold">Chairman, KPS</p>
              </div>
            </div>

          </div>
        </Container>
      </section>

      <section className="py-28 bg-white">
        <Container maxWidth="lg">
          <div className="grid md:grid-cols-2 gap-16 items-center">

            <div data-aos="fade-right">
              <img src={ManagerImg} alt="Manager" className="rounded-3xl shadow-2xl object-cover object-top w-full max-h-[500px]" />
            </div>

            <div data-aos="fade-left">
              <h2 className="text-4xl font-bold text-[#0A1F44] mb-6">
                From the Manager's Desk
              </h2>

              <p className="text-lg text-gray-700 leading-relaxed">
                Dear Parents,
                It gives me an immense pleasure as I introduce to KPS. KPS is an endeavour to facilitate quality education caters to the need to those parents who find it a fetched dream owing to remote that they hail from.
                <br /><br />
                KPS adopts latest pedagogical techniques, educational technology and continuous and comprehensive evaluation to guide learners, beside academics, we lay emphasis on physical, mental, emotional, spiritual and social development of a learners. To ensure the same, a spectrum of co-scholastic activities is an integral part of academic calendar of a KPSIAN.
                <br /><br />
                We assure you harmonious development of your ward under the guidance of experienced faculty and a pastoral care full of love and affection that your ward will never find himself or herself away from home.
                <br /><br />
                I Welcome all the parents and students to KPS and wish you may not get disappointed.
              </p>

              <div className="mt-6 border-l-4 border-red-600 pl-4">
                <p className="font-bold">Malti Porwal</p>
                <p className="text-red-600 font-semibold">Manager/Secratery, KPS</p>
              </div>
            </div>

          </div>
        </Container>
      </section>

      <section className="py-28 bg-[#F5F7FA]">
        <Container maxWidth="lg">
          <div className="grid md:grid-cols-2 gap-16 items-center">

            <div data-aos="fade-right">
              <h2 className="text-4xl font-bold text-[#0A1F44] mb-6">
                From the Director’s Desk
              </h2>

              <p className="text-lg text-gray-700 leading-relaxed">
                Like an oasis in the desert, Krishna Public School aims to quench
                the thirst for quality English-medium education for hundreds of
                families in Sikandra and surrounding areas.
                <br /><br />
                In a region with limited representation in professional fields,
                KPS serves as a launch pad for aspiring students — both girls and
                boys — to pursue meaningful careers and all-round development.
                <br /><br />
                As a parent myself, I understand the struggle of providing
                quality education. With KPS, I am confident that many families
                will see their children step confidently onto the path of
                success.
              </p>

              <div className="mt-6 border-l-4 border-red-600 pl-4">
                <p className="font-bold">Alok Porwal</p>
                <p className="text-red-600 font-semibold">Director, KPS</p>
              </div>
            </div>

            <div data-aos="fade-left">
              <img src={DirectorImg} alt="Director" className="rounded-3xl shadow-2xl object-cover object-top w-full max-h-[500px]" />
            </div>

          </div>
        </Container>
      </section>

      <section className="py-28 bg-[#0177b5]">
        <Container maxWidth="lg">
          <div className="grid md:grid-cols-2 gap-10">

            {[
              {
                title: "Our Vision",
                text:
                  "By providing a smart learning environment, motivated faculty, and world-class infrastructure, we envision empowering our children for life and strengthening our society and nation.",
              },
              {
                title: "Our Mission",
                text:
                  "To create a joyful, innovative, and value-driven learning environment that promotes all-round development and enables students to excel beyond academics.",
              },
            ].map((item, i) => (
              <div
                key={i}
                data-aos="zoom-in"
                className="bg-white/10 backdrop-blur-md border border-white/20 p-10 rounded-3xl shadow-xl text-white"
              >
                <h2 className="text-3xl font-bold text-white mb-4">
                  {item.title}
                </h2>
                <p className="text-lg leading-relaxed">{item.text}</p>
              </div>
            ))}

          </div>
        </Container>
      </section>

      <section className="py-24 bg-gradient-to-r from-red-600 to-[#ff4e1c] mb-2">
        <Container maxWidth="lg">
          <div className="bg-white rounded-3xl p-12 flex flex-col md:flex-row justify-between items-center gap-6 shadow-2xl" data-aos="zoom-in" >
            <div>
              <h2 className="text-3xl font-bold text-[#0A1F44] mb-2">
                Begin Your Child’s Learning Journey
              </h2>
              <p className="text-gray-600">
                Admissions are open. Join a school where learning meets values.
              </p>
            </div>

            <Button
              variant="contained"
              endIcon={<ArrowForward />}
              sx={{
                backgroundColor: "#dc2626",
                fontWeight: "bold",
                padding: "12px 34px",
                borderRadius: "10px",
                "&:hover": { backgroundColor: "#b91c1c" },
              }}
              onClick={() => navigate(`/AdmissionForm?Type=AdmissionForm`)}
            >
              Apply Now
            </Button>
          </div>
        </Container>
      </section>
    </div>
  );
};

export default Feature;
